import React from "react";
import { Home, Hammer, KeyRound } from "lucide-react";

const cards = [
  {
    icon: KeyRound,
    title: "Buy-to-Let",
    body:
      "Steady, reliable income from professionally sourced single-let properties — the foundation of long-term portfolio building. Ideal for investors seeking consistent returns and a scalable base of cash-flowing assets that compound over time.",
  },
  {
    icon: Home,
    title: "BRRR Strategy",
    body:
      "Buy, Refurbish, Refinance, Rent. We identify undervalued properties with strong refurbishment potential, helping you recycle your capital and scale your portfolio faster.",
  },
  {
    icon: Hammer,
    title: "Property Flips",
    body:
      "Buy undervalued, refurbish to a high standard, and sell for profit. We source refurb-ready opportunities with strong margins, full cost projections, and verified resale comparables — all packaged and ready to action.",
  },
];

export function Strategy() {
  return (
    <section
      id="strategy"
      data-testid="strategy-section"
      className="bg-[var(--ivory)] py-24 lg:py-32"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto reveal">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[var(--gold)]" />
            <span className="text-[0.7rem] tracking-[0.32em] uppercase text-[var(--gold-deep)]">
              What We Source For You
            </span>
            <span className="h-px w-10 bg-[var(--gold)]" />
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.05] text-[var(--navy)]">
            Three Strategies.
            <br />
            <span className="italic text-[var(--gold-deep)]">One Trusted Partner.</span>
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-8">
          {cards.map(({ icon: Icon, title, body }, i) => (
            <article
              key={title}
              data-testid={`strategy-card-${i}`}
              className="card-strategy reveal bg-[var(--navy)] text-[var(--ivory)] border border-[rgba(201,168,76,0.18)] p-8 lg:p-10 relative overflow-hidden"
            >
              <div className="absolute top-0 left-0 right-0 h-[2px] bg-[var(--gold)]" />
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 rounded-full border border-[rgba(201,168,76,0.4)] flex items-center justify-center text-[var(--gold)]">
                  <Icon size={20} />
                </div>
                <span className="text-[0.65rem] tracking-[0.24em] uppercase text-[var(--gold)]/80 mt-2">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-display text-[1.85rem] mt-8 leading-tight">{title}</h3>
              <p className="mt-4 text-[0.95rem] text-[var(--ivory)]/72 leading-relaxed">{body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
